module.exports = __webpack_public_path__ + "static/media/hrishikesh_athalye.115e669f.png";